export const useOrderAnalytics = (orders = []) => {
  return useMemo(() => {
    const monthlyRevenue = {};
    const statusCount = {};

    orders.forEach((order) => {
      // MONTHLY REVENUE
      const date = new Date(order.createdAt);
      const month = date.toLocaleString("default", { month: "short" });

      monthlyRevenue[month] =
        (monthlyRevenue[month] || 0) + order.totalAmount;

      // STATUS COUNT
      const status = order.status || "unknown";
      statusCount[status] = (statusCount[status] || 0) + 1;
    });

    return {
      revenueLabels: Object.keys(monthlyRevenue),
      revenueData: Object.values(monthlyRevenue),
      statusLabels: Object.keys(statusCount),
      statusData: Object.values(statusCount),
    };
  }, [orders]);
};